import {Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {TemplatePortal} from '@angular/cdk/portal';
import Env from '../../../env/env';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.css']
})
export class ImagePreviewComponent implements OnInit {
  @Input() imageUrl: string;
  @ViewChild('templatePortalContent', {static: false}) templatePortalContent: TemplateRef<any>;
  @ViewChild('pictureRelativeContainer', {static: false}) imageIcon: ElementRef;
  overlayRef: OverlayRef;
  imageCDN = Env.imageCDN;

  constructor(private overlay: Overlay, private viewContainerRef: ViewContainerRef) {
  }

  ngOnInit() {
  }

  displayPicture() {
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(this.imageIcon)
      .withPositions([{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top'
      }]);

    this.overlayRef = this.overlay.create({positionStrategy});


    const imagePortal = new TemplatePortal(this.templatePortalContent, this.viewContainerRef);
    this.overlayRef.attach(imagePortal);
  }

  hidePicture() {
    this.overlayRef.dispose();
  }
}
